const React = require("react")
const ReceivingType = ({ ...props }) => {
  return (
    <svg
      width="20"
      height="16"
      viewBox="0 0 20 16"
      xmlns="http://www.w3.org/2000/svg"
      fill="#0A645A"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.87868 0.87868C1.44129 0.31607 2.20435 0 3 0H17C17.7957 0 18.5587 0.31607 19.1213 0.87868C19.6839 1.44129 20 2.20435 20 3V13C20 13.7957 19.6839 14.5587 19.1213 15.1213C18.5587 15.6839 17.7957 16 17 16H3C2.20435 16 1.44129 15.6839 0.87868 15.1213C0.31607 14.5587 0 13.7956 0 13V3C0 2.20435 0.31607 1.44129 0.87868 0.87868ZM3 2C2.73478 2 2.48043 2.10536 2.29289 2.29289C2.10536 2.48043 2 2.73478 2 3V13C2 13.2652 2.10536 13.5196 2.29289 13.7071C2.48043 13.8946 2.73478 14 3 14H17C17.2652 14 17.5196 13.8946 17.7071 13.7071C17.8946 13.5196 18 13.2652 18 13V3C18 2.73478 17.8946 2.48043 17.7071 2.29289C17.5196 2.10536 17.2652 2 17 2H3ZM4.21913 4.37531C4.56414 3.94404 5.19343 3.87412 5.62469 4.21913L9.37469 7.21913C9.55206 7.36113 9.77279 7.43875 10 7.43875C10.2272 7.43875 10.4476 7.36138 10.625 7.21938L14.3753 4.21913C14.8066 3.87412 15.4359 3.94404 15.7809 4.37531C16.1259 4.80657 16.056 5.43586 15.6247 5.78087L11.875 8.78062C11.8749 8.78071 11.8751 8.78054 11.875 8.78062C11.343 9.20648 10.6815 9.43875 10 9.43875C9.31851 9.43875 8.65734 9.20672 8.12531 8.78087C8.1252 8.78079 8.12541 8.78095 8.12531 8.78087L4.37531 5.78087C3.94404 5.43586 3.87412 4.80657 4.21913 4.37531Z"
      />
    </svg>
  )
}

module.exports = {
  ReceivingType
}



// WEBPACK FOOTER //
// ./src/shared/skin/icons/iconlink/icons/receiving-type.js